import { SurveyInitialState } from '@r1-frontend/survey/context/reducer/initialState';

const getCommonSurveyButton = (state: SurveyInitialState) => state.surveyButton;

export default getCommonSurveyButton;
